import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const ScheduledMaintenanceOutageBanner = () =>
  import(/* webpackChunkName: "4-feat-scheduled-maintenance-outage-banner" */ './ScheduledMaintenanceOutageBanner');

const LoadableScheduledMaintenanceOutageBanner = lazyLoadOnRender({
  loader: ScheduledMaintenanceOutageBanner,
});
export default LoadableScheduledMaintenanceOutageBanner;
